import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { initLenis } from "./utils/lenis";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AmbientGlow from "./components/AmbientGlow";
import StickyNewsletterBar from "./components/StickyNewsletterBar";
import BackToTop from "./components/BackToTop";
import Home from "./pages/Home";
import EpisodesPage from "./pages/EpisodesPage";
import BlogPostPage from "./pages/BlogPostPage";
import AboutPage from "./pages/AboutPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ApplyPage from "./pages/ApplyPage";
import LibraryPage from "./pages/LibraryPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <BackToTop />
      <StickyNewsletterBar />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = initLenis();
    return () => { if (lenis) lenis.destroy(); };
  }, []);

  return (
    <div className="App">
      <AmbientGlow />
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/episodes" element={<PublicLayout><EpisodesPage /></PublicLayout>} />
            <Route path="/library" element={<PublicLayout><LibraryPage /></PublicLayout>} />
            <Route path="/blog" element={<Navigate to="/episodes" replace />} />
            <Route path="/blog/:slug" element={<PublicLayout><BlogPostPage /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
            <Route path="/apply" element={<PublicLayout><ApplyPage /></PublicLayout>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<PublicLayout><AdminDashboard /></PublicLayout>} />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
